import React from 'react';
const coverage = [{
  label: 'Team types',
  body: 'All-star, high school, middle school, rec, mixed'
}, {
  label: 'Season phases',
  body: 'Tryouts, pre-season, competition, sideline, off-season'
}, {
  label: 'Skills',
  body: 'Motions, jumps, tumbling prep, stunts, pyramids'
}, {
  label: 'Safety',
  body: 'Spotting protocol and readiness checks in every progression'
}, {
  label: 'Admin',
  body: 'Scorecards, contracts, budgets, incident reports'
}, {
  label: 'Formats',
  body: '60 and 90-minute practice blocks, printable'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-173" data-mp="2n3fnq2lvvqv1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-174" data-mp="2iaw7syzq4jn2">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-175" data-mp="1um3aay3ge3qc">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-176" data-mp="1pn09xqyf4lop">
          The Open &amp; Coach System™
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-177" data-mp="1f1808rm2lnw2">
          A full season of practices, written and sequenced. Every session comes
          with time blocks in 60 and 90-minute formats, progressions in a safe
          order, and stations so no athlete is standing around. You open the
          day&apos;s practice and coach it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-178" data-mp="w2wwefduabkf">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-179" data-mp="111zxxpum1znn">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-180" data-mp="2chx38omraw71">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-181" data-mp="2hfq73b0l7e45">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}